export const CONSTRAINTS = {
  MAX_DESCRIPTION_LENGTH: 165,
  MAX_TITLE_LENGTH: 60,
  MAX_PATH_LENGTH: 60,
  MIN_PASSCODE_LENGTH: 4,
  MAX_PASSCODE_LENGTH: 20,
  MAX_PASSCODE_HELP_TEXT_LENGTH: 165,
};

export const SITE_PROTECTION = {
  PUBLIC: 'PUBLIC',
  RESTRICTED: 'RESTRICTED',
} as const;

export const VALID_SITE_URL = /^[a-zA-Z0-9\-_]*$/;

export const VALID_PASSCODE = /^[a-zA-Z0-9]*$/;

export const PASSCODE_ACCESS_WINDOW_DAYS = 30;
